import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialAccessImageDesktopWebp from './images/financial-access-desktop.webp';
import financialAccessImageMobileWebp from './images/financial-access-mobile.webp';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-financial-access'
    themeType='lightTheme'
    backgroundVariant='lightB'
    moduleName='financial-planning-module'
    reverseContent
    // content
    subHeadingText={<>Delivering financial security and expanding <WidowBlock>financial access</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          We exist to help people build financial security today and for years to come. As a mutual company, it&#39;s in our DNA.
        </Typography>
        <Link
          id='sustainability-impact-financial-access-link'
          variant='buttonLinkSecondary'
          linkUrl='/who-we-are/sustainability-impact/financial-access/'
          ariaLabel='Find out more about financial access.'>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='A man having dinner with a married couple in front of a beautiful lake'
    imageSrcDefault={financialAccessImageDesktopWebp}
    imageSrcMobile={financialAccessImageMobileWebp}
  />
);
